<template>
  <div>
    <portal to="property-mobile-search">
      <div class="container-fluid plr-80">
        <b-form-input
          v-model="location.destination"
          :placeholder="searchPlaceholder"
          class="search-icon g-input"
          autocomplete="off"
          id="search-form-mobile"
          @keypress.enter="findPlaces"
          @click="$refs.typesenseSearchMobile.show()"
        ></b-form-input>
        <TypesenseSearch
          ref="typesenseSearchMobile"
          @select="location = $event"
          top="50px"
        />
      </div>
      <div class="container-fluid plr-80">
        <div>
          <b-form-input
            :placeholder="$t('products.checkIn')"
            class="input check-out my-2 g-input"
            id="from-mobile"
            readonly
            v-model="date.checkIn"
          ></b-form-input>
          <b-form-input
            :placeholder="$t('products.checkOut')"
            class="input my-2 g-input"
            v-model="date.checkOut"
            id="to-mobile"
            readonly
          ></b-form-input>
        </div>
        <button
          class="btn btn-block mt-3 g-tertiary-button"
          @click="findPlaces"
        >
          {{ $t(`listing.${location.propertyId ? "openProperty" : "search"}`) }}
        </button>
      </div>
    </portal>

    <div class="search-wrapper custom-calender g-search-widget">
      <h2>{{ $t("listing.search") }}</h2>
      <div class="form-outer">
        <b-row class="mb-2">
          <b-col md="12">
            <label for="input-small">{{ $t("listing.destination") }}</label>
          </b-col>
          <b-col md="12">
            <div class="relative">
              <b-form-input
                id="search-form"
                autocomplete="off"
                :placeholder="searchPlaceholder"
                class="input check-in g-input"
                :value="location.destination"
                readonly
                @click="$refs.typesenseSearchDesktop.show()"
              ></b-form-input>
              <b-button
                v-if="location.destination || location.latitude || location.longitude"
                variant="link"
                class="position-absolute p-1 clear-location-btn"
                @click="clearLocation"
                aria-label="Clear location"
              >
                <b-icon icon="x" aria-hidden="true"></b-icon>
              </b-button>
              <TypesenseSearch
                ref="typesenseSearchDesktop"
                @select="location = $event"
                top="50px"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12 mb-2">
            <label for="input-small">{{ $t("products.checkIn") }}</label>
            <b-form-input
              :placeholder="$t('products.checkIn')"
              class="input check-out g-input"
              id="from-desktop"
              readonly
              v-model="date.checkIn"
            ></b-form-input>
          </b-col>
          <b-col md="12 mb-2">
            <label for="input-small">{{ $t("products.checkOut") }}</label>
            <b-form-input
              :placeholder="$t('products.checkOut')"
              class="input g-input"
              id="to-desktop"
              v-model="date.checkOut"
              readonly
            ></b-form-input>
          </b-col>
          <b-col
            @click="clearDate"
            v-if="date.checkIn || date.checkOut"
            class="small cursor-pointer"
            md="12 mb-2"
          >
            <b-icon icon="x"></b-icon>
            {{ $t("listing.clearDateSelections") }}
          </b-col>
        </b-row>
        <b-row class="submit-wrapper mt-2">
          <b-col md="12">
            <b-button class="g-tertiary-button" @click="findPlaces">{{
              $t(`listing.${location.propertyId ? "openProperty" : "search"}`)
            }}</b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { reloadRoute } from "../../helpers";
import { currentConfigKey } from "../../helpers/theme";
import TypesenseSearch from "./TypesenseSearch.vue";
import DateRangePicker from "../../helpers/datepicker/index";
export default {
  name: "PropertySearchMobile",
  components: {
    TypesenseSearch,
  },
  computed: {
    searchPlaceholder() {
      if (currentConfigKey("mergeTypesenseSearchResult", false)) {
        return this.$t("listing.searchLocationOrPropertyName");
      }
      return this.$t("listing.searchLocation");
    },
  },
  async mounted() {
    const { checkIn, checkOut, destination, latitude, longitude } =
      this.$route.query;
    if (checkIn && checkOut) {
      this.date.checkIn = moment(checkIn, "YYYY-MM-DD").format("DD MMM YYYY");
      this.date.checkOut = moment(checkOut, "YYYY-MM-DD").format("DD MMM YYYY");
    }

    if (destination && latitude && longitude) {
      this.location = { destination, latitude, longitude };
    }

    setTimeout(() => {
      const options = {
        smartCalendar: false,
        defaultFromDate: checkIn
          ? moment(checkIn, "YYYY-MM-DD").toDate()
          : null,
        defaultToDate: checkOut
          ? moment(checkOut, "YYYY-MM-DD").toDate()
          : null,
      };
      if (window.innerWidth > 767) {
        new DateRangePicker("#from-desktop", "#to-desktop", options);
      } else {
        new DateRangePicker("#from-mobile", "#to-mobile", options);
      }
    }, 1000);
  },
  data() {
    return {
      date: {
        checkIn: null,
        checkOut: null,
      },
      location: {
        destination: "",
        latitude: 0,
        longitude: 0,
      },
    };
  },
  methods: {
    clearDate() {
      this.date.checkIn = null;
      this.date.checkOut = null;
      const { date, location } = this;

      const query = { ...this.$route.query };
      delete query.checkIn;
      delete query.checkOut;

      reloadRoute(query);
      this.$emit("findPlaces", { date, location });
    },
    findPlaces() {
      const { date, location } = this;
      const { checkIn, checkOut } = date;
      const { latitude, longitude, destination } = location;

      const query = { ...this.$route.query };

      if (checkIn && checkOut) {
        query.checkIn = moment(checkIn, "DD MMM YYYY").format("YYYY-MM-DD");
        query.checkOut = moment(checkOut, "DD MMM YYYY").format("YYYY-MM-DD");
      }

      if (latitude && longitude) {
        query.latitude = latitude;
        query.longitude = longitude;
        if (destination) {
          query.destination = destination;
        }
      } else {
        delete query.latitude;
        delete query.longitude;
        delete query.destination;
      }

      reloadRoute(query);
      this.$emit("findPlaces", { date, location });
    },
    clearLocation() {
      this.location = { destination: "", latitude: 0, longitude: 0 };
      const query = { ...this.$route.query };
      delete query.destination;
      delete query.latitude;
      delete query.longitude;
      reloadRoute(query);
      this.$emit("findPlaces", { date: this.date, location: this.location });
    },
  },
};
</script>

<style scoped>
.clear-location-btn {
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  font-size: 14px;
}
</style>
